module.exports = __webpack_public_path__ + "img/cw.d0e7be97.svg";